export enum TaskListFilterOption {
  ASSIGNED_USER = "assignedUserId",
  ASSIGNED_BY_USER = "assignedByUserId",
  TASK_TYPE = "taskTypeId",
  STATUS = "status",
  DEPARTMENT = "departmentId",
  ASSIGNED_ON_ME = "assignedOnMe",
  HIDE_COMPLETED = "hideCompleted",
  CREATED_DATE_FROM = "createdDateFrom",
  CREATED_DATE_TO = "createdDateTo",
}
